<template>
  <div class="flex items-center gap-2">
    <button
      class="btn btn-xs btn-primary"
      @click="handleShowDetail"
    >
      Détails
    </button>
  </div>
</template>

<script setup lang="ts">
import { inject } from 'vue'

interface Props {
  data: any
  params?: any
}

const props = defineProps<Props>()

const onShowDetail = inject<(derogation: any) => void>('onShowDerogationDetail')

const handleShowDetail = () => {
  
  const derogationData = props.data || props.params?.data
  onShowDetail?.(derogationData)
}
</script>
